export const education = [
  {
    year:'2011',
    company:'UTCAM',
    title:'TSU en Mecatrónica',
    content:'Tecnico Superior Universitario en Mecatrónica área automatización',
  },
  {
    year:'2013',
    company:'UTCAM',
    title:'Ingenieria en Mecatrónica',
    content:'Ingeniero en Mecatrónica, enfocado en el desarrollo y programación de interfaces humano maquina.',                    
  },
  {
    year:'2021',
    company:'Academlo',
    title:'Fullstack Developer & computer science',
    content:'Desarrollando habilidades de fullstack developer, desde html, css, js, react, node, express, python, bases de datos, trabajo en equipo, control de versiones git, algoritmos y estructuras de datos.'
  },
]

export const experience = [
  {
    year:'2017-2021',
    company:'Instituto Gardner',
    title:'Profesor de Informática y Tecnología',
    content:'Imparto las materias de Tecnología en nivel secundaria, dando temas de fundamentos de programación en lenguajes de bloques y swift. A nivel preparatoria imparto la materia de informatica, dando temas introductorios HTML, CSS y JS.'
  },
  {
    year:'2021',
    company: 'Academlo',
    title: 'Fullstack Developer & computer science',
    content: 'He desarrollado proyectos con Java Script Vanilla, HTML y CSS, también usando react junto con librerias como react-router, context y redux. También desarrollando las habilidades de trabajo en equipo con proyectos realizados.'
  },
  {
    year:'2021',
    company:'Ali mx',
    title:'React Frontend Developer',
    content:'Ddesarrollo de entrenamientos financieros para las plataformas de coru y kanda. Usando react, styled-components, boostrap, css, react-router'
  },
];

export const technicalSkills = [
  {
    skillName:'HTML',
    skillPercentage:'85%'
  },
  {
    skillName:'CSS',
    skillPercentage:'80%'
  },
  {
    skillName:'JavaScript',
    skillPercentage:'85%'
  },
  {
    skillName:'React',
    skillPercentage:'80%'
  }
];

export const softSkills = [
  {
    skillName:'Aprendizaje rápido',
    skillPercentage:'100%'
  },
  {
    skillName:'Resolución de Problemas',
    skillPercentage:'100%'
  },
  {
    skillName:'Trbajo en Equipo',
    skillPercentage:'100%'
  },
  {
    skillName:'Facliidad de Palabra',
    skillPercentage:'100%'
  }
]
